/**
 * MeetingActionItemStatusService
 * Service for MeetingActionItemStatus entity operations
 * Route: api/meetingactionitemstatuses
 * Controller: MeetingActionItemStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingActionItemStatusService
 * Handles meeting action item status CRUD operations
 * Maps to /api/meetingactionitemstatuses endpoint
 */
export class MeetingActionItemStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingActionItemStatusService.DEFAULT_SERVICE_PATH,
            basePath: MeetingActionItemStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingActionItemStatusService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingActionItemStatusService.BASE_PATH = 'api/meetingactionitemstatuses';
//# sourceMappingURL=MeetingActionItemStatusService.js.map